import { MouseEventHandler } from 'react';
import ChevronIcon from 'components/Shared/ChevronIcon';
import styles from './styles';

interface DropdownHeaderProps {
  isPointedUp?: boolean;
  title: string;
  onClick?: MouseEventHandler<HTMLSpanElement>;
  disabled?: boolean;
}

function DropdownHeader({
  isPointedUp = false,
  title,
  onClick,
  disabled,
}: DropdownHeaderProps): JSX.Element {
  return (
    <div
      className={`dropdown-header ${disabled && 'header-disabled'}`}
      data-testid="dropdown-header"
      onClick={onClick}
      role="button"
    >
      <span className="dropdown-title">{title}</span>
      <ChevronIcon isPointedUp={isPointedUp} data-testid="chevron-icon" />
      <style jsx>{styles}</style>
    </div>
  );
}
export default DropdownHeader;
